export enum ErrorResponseCodes {
  AUTH_FAILURE = "MFC_AUTH_001",
  LOCKED_REF = "MFC_AUTH_002",
  LOCKED_SESSION = "MFC_AUTH_003",
  UPDATE_ERROR = "MFC_UPDATE_001",
  BANK_VALIDATION_PAUSED = "MFC_BANK_VALIDATION_001",
  BANK_VALIDATION_LOCKED = "MFC_BANK_VALIDATION_002",
  BANK_VALIDATION_MODULUS = "MFC_BANK_VALIDATION_003",
  UNEXPECTED_ERROR = "MFC_UNEXPECTED_001",
}
